<script>
import Layout from "../../layouts/main.vue";
import PageHeader from "@/components/page-header";
import appConfig from "../../../app.config";
import axios from 'axios';

import Swal from "sweetalert2";

export default {
  page: {
    title: "QC Assessment",
    meta: [{ name: "description", content: appConfig.description }],
  },
  data() {
    return {
      title: "Quotation",
      items: [
        {
          text: "Order",
          href: "/",
        },
        {
          text: "",
          active: true,
        },
      ],
        //detail order list
        DetailOrder:[],
        OrderListGrading:[],

        //end of detail order list

        //wiget spinner
        OrderSeen:true,
        //end of wiget spinner

        //hide and show

        UploadSuccess:false,
        OrderGradingSeen:false,
        staticURLDownload: process.env.VUE_APP_API_BASEURL,
        

        TotalAmount:0,  //final amount after grading or not
        
    };
  },

    methods: {
        getOrderDetails(){
            this.staticURLDownload = this.staticURLDownload.replace('/api','');
            axios.defaults.headers.common['authorization'] = 'Bearer ' + localStorage.getItem('jwt')
            axios.get(process.env.VUE_APP_API_BASEURL+'order/'+this.$route.params.OrderId)
            .then(response => {
                if (response) {
                    if(response.data.status=='error'){
                        this.messageBag = response.data.msj;
                        this.OrderSeen = false;
                    }else{
                        this.OrderList = response.data['0'];
                        this.OrderSeen = false;
                        
                        this.TotalAmount = this.OrderList.totalQuotation; //final amount
                        
                        this.items['2'].text = this.OrderList.Order_id;
                    }
                    
                } else {
                    this.messageBag = ['No record.'];
                    this.OrderSeen = false;
                }
            })
                .catch(error => {
                    this.messageBag = [error.error];
                    this.OrderSeen = false;
            });
        },

        getGradingDevice(){
            axios.defaults.headers.common['authorization'] = 'Bearer ' + localStorage.getItem('jwt')
            axios.get(process.env.VUE_APP_API_BASEURL+'grading/'+this.$route.params.OrderId)
            .then(response => {
                if (response) {
                    if(response.data.status=='error'){
                        this.messageBag = response.data.msj;
                        this.OrderGradingSeen = false;
                    }else{
                        this.OrderListGrading = response.data['0'];
                        // console.log(this.OrderListGrading);
                        // console.log('---------');
                        // console.log(this.OrderListGrading.devices['0']);
                        if(this.OrderListGrading.devices['0'].id){
                            this.OrderGradingSeen = true;
                            // console.log('**********');
                            this.TotalAmount = this.OrderListGrading.totalQuotation; //final amount grading
                        }
                        
                        
                        // this.items['2'].text = this.OrderList.Order_id;
                    }
                    
                } else {
                    this.messageBag = ['No record.'];
                    this.OrderGradingSeen = false;
                }
            })
                .catch(error => {
                    this.messageBag = [error.error];
                    this.OrderGradingSeen = false;
            });
        },

        submitFile() {
            this.orderID_=null;
            const formData = new FormData();
            formData.append('uploaded_file', this.Images);


            const headers = { 'Content-Type': 'multipart/form-data' };
            axios.defaults.headers.common['authorization'] = 'Bearer ' + localStorage.getItem('jwt')
            axios.post(process.env.VUE_APP_API_BASEURL+'order/garding/'+this.$route.params.OrderId, formData, 
                { headers }
            ).then((res) => {
                    this.DevicesUpload ='';
                    // console.log(res.data);
                    // console.log(res.data.id);

                    if(res.data.status=='error'){
                        this.messageBag = res.data.msj;
                        this.isLoadingListDevices = false;
                        this.getUploadDevicesSeen = false;
                    }else{
                        this.getGradingDevice();
                        this.UploadSuccess = true;
                    }
                    
                }
            );
        },

        uploadFile() {
            this.Images = this.$refs.file.files[0];
        },


        rejectButton() {
            Swal.fire({
                title: "Are you sure you want to reject this quotation?",
                // text: "You won't be able to revert!",
                icon: "warning",
                showCancelButton: true,
                confirmButtonColor: "#f46a6a",
                cancelButtonColor: "#34c38f",
                confirmButtonText: "Yes",
            }).then((result) => {
                if (result.value) {
                    const posting_ = { status: "9" };
                    axios.defaults.headers.common['authorization'] = 'Bearer ' + localStorage.getItem('jwt')
                    axios.post(process.env.VUE_APP_API_BASEURL+'order/status/'+this.$route.params.OrderId, posting_)
                    .then(response => {
                        if (response) {
                            Swal.fire("Purchase Order Rejected!", "Your purchase order has been rejected.", "success");
                            this.SeenButton = false;
                            this.getOrderDetails();
                            this.getGradingDevice();
                        }else{
                            Swal.fire("Fail!", "Your quotation failed to be rejected. Please try again", "fail");
                        }
                    });
                }
            });
        },

        ApproveButton() {
            Swal.fire({
                title: "Are you sure you want to approve this quotation?",
                // text: "You won't be able to revert!",
                icon: "info",
                showCancelButton: true,
                confirmButtonColor: "#34c38f",
                cancelButtonColor: "#f46a6a",
                confirmButtonText: "Yes",
            }).then((result) => {
                if (result.value) {

                    const posting_ = { status: "6" };
                    axios.defaults.headers.common['authorization'] = 'Bearer ' + localStorage.getItem('jwt')
                    axios.post(process.env.VUE_APP_API_BASEURL+'order/status/'+this.$route.params.OrderId, posting_)
                    .then(response => {
                        if (response) {
                            Swal.fire("Purchase Order Confirmed!", "Your payment will be processed soon.", "success");
                            this.SeenButton = false;
                            this.getOrderDetails();
                            this.getGradingDevice();
                        }else{
                            alert(response);
                            Swal.fire("Fail!", "Your Order Fail To Rejected. Please try again", "fail");
                        }
                    });
                    
                }
            });
        },
    },

    mounted() {
        this.getOrderDetails();
        this.getGradingDevice();
    },

  components: {
    Layout,
    PageHeader,
  },
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
          
          <div class="row">
            <div class="col-lg-12">
                <div v-if='OrderSeen'>
                        <div class="spinner-border text-success" role="status">
                            <span class="sr-only">Loading...</span>
                        </div>
                </div>
                <div v-else>
                    <div class="card">                        
                        <div class="card-body">
                            <br>
                            <div class="row align-items-center g-12">
                                <div class="col-lg-12">

                                    <div class="row">
                                        <div class="col-lg-6">
                                            <table>
                                                <tr>
                                                    <td><p class="fs-6"><b>Person In Charge</b></p></td>
                                                    <td><p class="fs-6">{{ OrderList.user }}</p></td>
                                                </tr>

                                                <tr>
                                                    <td><p class="fs-6"><b>Company Name</b></p></td>
                                                    <td><p class="fs-6">{{ OrderList.Company }}</p></td>
                                                </tr>

                                                <tr>
                                                    <td><p class="fs-6"><b>Company Address</b></p></td>
                                                    <td><p class="fs-6">{{ OrderList.Address }} </p></td>
                                                </tr>
                                                
                                            </table>
                                        </div>
                                        <div class="col-lg-6">
                                            <table>
                                                <tr>
                                                    <td><p class="fs-6"><b>No. Of Devices</b></p></td>
                                                    <td><p class="fs-6">{{ OrderList.quantity }}</p></td>
                                                </tr>

                                                <tr>
                                                    <td><p class="fs-6"><b>Total Amount</b></p></td>
                                                    <td><p class="fs-6">{{ OrderList.currency }} {{ TotalAmount }}</p></td>
                                                </tr>

                                                <tr>
                                                    <td><p class="fs-6"><b>Status</b></p></td>
                                                    <td><p class="fs-6">{{ OrderList.Status }}</p></td>
                                                </tr>
                                                
                                                
                                            </table>
                                        </div>
                                        
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div v-if="OrderGradingSeen">
                        
                        <div class="card">   
                            <div class="card-header align-items-center d-flex">
                                <h4 class="card-title mb-0 flex-grow-1">Quotation Upon CompAsia assessment</h4>
                            </div>                       
                            <div class="card-body">
                                <br>
                                <div class="row align-items-center g-12">
                                    <div class="col-lg-12">
                                        <div class="table-responsive table-card">
                                            <table class="table align-middle table-nowrap mb-0">
                                                <thead >
                                                    <tr>
                                                        <th scope="col">NO.</th>
                                                        <th scope="col">MODEL</th>
                                                        <th scope="col">BRAND NAME</th>
                                                        <th scope="col">CAPACITY</th>
                                                        <th scope="col">IMEI</th>
                                                        <th scope="col">GRADING</th>
                                                        <th scope="col">PRICE</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    <tr v-for="(item, index) in OrderListGrading.devices" :key="index" class="content">
                                                        <td>{{ index+1 }}</td>
                                                        <td>{{ item.model }}</td>
                                                        <td>{{ item.brand }}</td>
                                                        <td>{{ item.storage }}</td>
                                                        <td>{{ item.imei }}</td>
                                                        <td>{{ item.condition }}</td>
                                                        <td>{{ OrderList.currency }} {{ item.price }}</td>
                                                    </tr>
                                                    <tr>
                                                        <td colspan="6">
                                                            <p class="fs-6">&emsp;<b>TOTAL</b></p>
                                                        </td>
                                                        <td>
                                                            <b>{{ OrderList.currency }} {{ OrderListGrading.totalQuotation }}</b>
                                                        </td>
                                                    </tr>
                                                    <tr v-if="OrderList.StatusId == '5'">
                                                    <td colspan="2">
                                                        <button class="btn btn-danger waves-effect" @click="rejectButton(orderId)" type="button"> Reject </button> {{ " "}}{{ " "}}
                                                        <button class="btn btn-secondary bg-gradient waves-effect waves-light" @click="ApproveButton(orderId)" type="button"> Accept </button>
                                                    </td>
                                                </tr>
                                                </tbody>
                                            </table>
                                        
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                </div>
            </div>
        </div>

    </Layout>
</template>